import { useLanguage } from "@/context/LanguageContext";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { HelpCircle } from "lucide-react";
import SectionLabel from "@/components/SectionLabel";

export default function FAQ() {
  const { t } = useLanguage();
  const items = t("faq.items");

  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative bg-[#FAFAF7] paper-grain border-t border-[#F0EBE0] overflow-hidden"
    >
      <div className="container-iko relative py-24 lg:py-36">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-start">
          <div className="lg:col-span-5 lg:sticky lg:top-28">
            <SectionLabel icon={HelpCircle}>{t("faq.eyebrow")}</SectionLabel>
            <h2 className="font-display font-semibold text-4xl lg:text-6xl leading-[1.02] tracking-[-0.034em] text-balance text-[#1A1814]">
              {t("faq.title")}
            </h2>
          </div>

          <div className="lg:col-span-7">
            <Accordion type="single" collapsible className="w-full">
              {items.map((item, i) => (
                <AccordionItem
                  key={i}
                  value={`item-${i}`}
                  className="border-b border-[#ECE8DD] last:border-b-0 rounded-none"
                  data-testid={`faq-item-${i}`}
                >
                  <AccordionTrigger className="font-display font-bold text-lg lg:text-xl py-6 hover:no-underline text-left tracking-[-0.02em] text-[#1A1814] [&[data-state=open]>svg]:text-[#437DEA]">
                    {item.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-[#6B6862] text-base leading-relaxed pb-6 max-w-2xl">
                    {item.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
}
